import { RangeState, SensitiveData } from '@philips-internal/oswald-ui-constants';
import { array, arrayOf, bool, eventListener, expression, number, oneOf, oneOfType, shape, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
const DateFieldProperties = {
    applyExpression: {
        defaultValue: 'tws.date-field.apply',
        type: expression,
    },
    clearExpression: {
        defaultValue: 'tws.date-field.clear',
        type: expression,
    },
    data: {
        type: array,
    },
    enabled: {
        defaultValue: true,
        type: bool,
    },
    initialDate: {
        type: string,
    },
    interval: {
        defaultValue: false,
        type: bool,
    },
    intervalThreshold: {
        defaultValue: 0,
        type: number,
    },
    noAppointmentsExpression: {
        type: expression,
    },
    onAfterNavigate: {
        type: eventListener,
    },
    onBlur: {
        type: eventListener,
    },
    onChange: {
        type: eventListener,
    },
    onNavigate: {
        type: eventListener,
    },
    openCalendarLabel: {
        defaultValue: 'tws.date-field.calendar-button-aria-label',
        type: expression,
    },
    placeholder: {
        type: expression,
    },
    ranges: {
        defaultValue: [],
        type: arrayOf(shape({ endDate: string, startDate: string })).notEnumerable(),
    },
    rangeState: {
        defaultValue: RangeState.DISABLED,
        type: oneOf(enumValues(RangeState)),
    },
    readOnly: {
        type: bool,
    },
    sensitiveData: {
        type: oneOf(enumValues(SensitiveData)),
    },
    strikethrough: {
        type: bool,
    },
    todayExpression: {
        defaultValue: 'tws.date-field.today',
        type: expression,
    },
    uuid: {
        type: string,
    },
    valid: {
        defaultValue: true,
        type: bool,
    },
    value: {
        type: oneOfType([string, arrayOf(string)]),
    },
};
export { DateFieldProperties, };
//# sourceMappingURL=date-field-types.js.map